<template>
  <div>
    <v-toolbar flat color="white">
      <v-toolbar-title>Plagas y Enfermedades</v-toolbar-title>
      <v-divider
        class="mx-2"
        inset
        vertical
      ></v-divider>
      <v-spacer></v-spacer>
      <v-dialog v-model="dialog" max-width="1300px">
        <template v-slot:activator="{ on }">
          <v-btn color="primary" dark class="mb-2" v-on="on">Nuevo Ingreso</v-btn>
        </template>
        <v-card>
          <v-card-title>
            <span class="headline">{{ formTitle }}</span>
          </v-card-title>

          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 sm6 md6>
                  <v-text-field v-model="editedItem.tunnel" label="Tunel" placeholder="1"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 m6>
                  <v-text-field v-model="editedItem.date" label="Fecha"></v-text-field>
                </v-flex>
                <v-flex xs12 sm2 md2>
                  <v-text-field v-model="editedItem.line" label="Linea"></v-text-field>
                </v-flex>
                <v-flex xs12 sm2 md2>
                  <v-text-field v-model="editedItem.block" label="Bloque"></v-text-field>
                </v-flex>
                <v-flex xs12 sm2 md2>
                  <v-text-field v-model="editedItem.phenology" label="Fenologia"></v-text-field>
                </v-flex>
                <v-flex xs12 sm2 md2>
                  <v-text-field v-model="editedItem.finding" label="Hallazgo"></v-text-field>
                </v-flex>
                <v-flex xs12 sm2 md2>
                  <v-text-field v-model="editedItem.plant" label="Plantas"></v-text-field>
                </v-flex>
                <v-flex xs12 sm2 md2>
                  <v-text-field v-model="editedItem.quantity" label="Rango"></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="close">Cancelar</v-btn>
            <v-btn color="blue darken-1" flat @click="save">Guardar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-toolbar>
    <v-data-table
      :headers="headers"
      :items="entry"
      :pagination.sync="pagination"
      class="elevation-1"
    >
      <template v-slot:items="props">
        <td class="text-xs-right">{{ props.item.tunnel }}</td>
        <td class="text-xs-right">{{ props.item.line }}</td>
        <td class="text-xs-right">{{ props.item.block }}</td>
        <td class="text-xs-right">{{ props.item.phenology }}</td>
        <td class="text-xs-right">{{ props.item.finding }}</td>
        <td class="text-xs-right">{{ props.item.plant }}</td>
        <td class="text-xs-right">{{ props.item.quantity }}</td>
        <td class="text-xs-right">{{ props.item.date }}</td>
        <td class="justify-center layout px-0">
          <v-icon
            small
            @click="deleteItem(props.item)"
          >
            delete
          </v-icon>
        </td>
      </template>
    </v-data-table>
  </div>
</template>

<script>
  export default {
    data: () => ({
      pagination: {
        descending: true,
        page: 1,
        rowsPerPage: 25,
        totalItems: 0,
      },
      dialog: false,
      headers: [
        { text: 'Tunel', value: 'tunnel' },
        { text: 'Linea', value: 'line' },
        { text: 'Bloque', value: 'block' },
        { text: 'Fenologia', value: 'phenology' },
        { text: 'Hallazgo', value: 'finding' },
        { text: 'Plantas', value: 'plant' },
        { text: 'Rango', value: 'quantity' },
        { text: 'Fecha', value: 'date' },
        { text: 'Eliminar', value: 'name', sortable: false }
      ],
      entry: [],
      editedIndex: -1,
      editedItem: {
      },
      defaultItem: {
      }
    }),

    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'Nuevo Ingreso' : 'Edit Item'
      }
    },

    watch: {
      dialog (val) {
        val || this.close()
      }
    },

    created () {
      this.initialize()
      this.editedItem.date = `${new Date().getDate()}/${new Date().getMonth()}/${new Date().getFullYear()}`
    },

    methods: {
      initialize () {
        this.entry = [
        ]
      },

      deleteItem (item) {
        const index = this.entry.indexOf(item)
        confirm('Are you sure you want to delete this item?') && this.entry.splice(index, 1)
      },

      close () {
        this.dialog = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },

      save () {
        if (this.editedIndex > -1) {
          Object.assign(this.entry[this.editedIndex], this.editedItem)
        } else {
          this.entry.push(this.editedItem)
        }

        this.$axios.post("/api/PestsReports/", this.editedItem)
        .then(response => {
          console.log("yessssss")
        })
        .catch(e => {
          console.log(e);
        });

        this.close()
      }
    }
  }
</script>

<style scoped>
  .v-card {
    padding: 30px !important;
  }
</style>
